import { SYNC_INELIGIBLE_REASON } from '../../product-inventory-sync-types';
import { messages } from './connection-sync-table.messages';

export const INELIGIBLE_REASON_MESSAGES = {
  [SYNC_INELIGIBLE_REASON.notATarget]: messages.notATargetTooltip,
  [SYNC_INELIGIBLE_REASON.targetUnsupported]: messages.targetUnsupportedTooltip,
} as const;
